import { useEffect, useState } from 'react'

/**
 * A clock that re-renders every `intervalMs` so the map can re-evaluate
 * free/paid status as real time advances. Aligns roughly to the minute.
 */
export function useClock(intervalMs = 30_000) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
